import { render, staticRenderFns } from "./GameMedia.vue?vue&type=template&id=0dd325c2&scoped=true&"
import script from "./GameMedia.vue?vue&type=script&lang=js&"
export * from "./GameMedia.vue?vue&type=script&lang=js&"
import style0 from "./GameMedia.vue?vue&type=style&index=0&id=0dd325c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd325c2",
  null
  
)

export default component.exports